const SUPER_ADMIN_ROLE_ID = 1
const LOAD_ERROR = 'Could not load the doctors ranking.'

function numeric(value) {
  if (value == null || value === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

function plainNumber(value) {
  const number = numeric(value)
  return number == null ? '' : number
}

function nameCompare(a, b) {
  return String(a.doctor_name || '').localeCompare(String(b.doctor_name || ''))
}

export function hasSales(row) {
  if (typeof row.has_sales === 'boolean') return row.has_sales
  return row.avg_np != null || row.avg_nc != null
}

export function partialTag(row) {
  if (!hasSales(row)) return ''
  if (row.avg_np != null && row.avg_nc == null) return 'Solo NP'
  if (row.avg_nc != null && row.avg_np == null) return 'Solo NC'
  return ''
}

export function canSeeNoSales(roleId) {
  return Number(roleId) === SUPER_ADMIN_ROLE_ID
}

export function visibleRankingRows(rows, roleId) {
  return canSeeNoSales(roleId) ? rows : rows.filter(hasSales)
}

export function splitBySales(rows) {
  return {
    withSales: rows.filter(hasSales),
    withoutSales: rows.filter(row => !hasSales(row)).sort(nameCompare),
  }
}

export function positionText(row) {
  if (row.position != null) return row.position
  return hasSales(row) ? '—' : 'Sin ventas'
}

function sortValue(row, sortBy) {
  if (sortBy === 'doctor_name') {
    const name = String(row.doctor_name || '').trim()
    return name ? name.toLocaleLowerCase() : null
  }
  if (sortBy === 'income') return numeric(row.income && row.income.total)
  if (sortBy === 'np_30_count' || sortBy === 'nc_30_count') return numeric(row[sortBy]) || 0
  return numeric(row[sortBy])
}

export function sortRankingRows(rows, sortBy, sortDir) {
  const { withSales, withoutSales } = splitBySales(rows)
  if (!sortBy) return withSales.concat(withoutSales)
  const direction = sortDir === 'asc' ? 1 : -1
  const sorted = withSales.slice().sort((a, b) => {
    const left = sortValue(a, sortBy)
    const right = sortValue(b, sortBy)
    if (left == null && right == null) return nameCompare(a, b)
    if (left == null) return 1
    if (right == null) return -1
    if (left === right) return nameCompare(a, b)
    return left < right ? -direction : direction
  })
  return sorted.concat(withoutSales)
}

export function rankingKpis(rows) {
  const { withSales, withoutSales } = splitBySales(rows)
  const topAverage = withSales.reduce((top, row) => {
    const value = numeric(row.avg_nc_np)
    if (value == null) return top
    return top == null || value > top ? value : top
  }, null)
  return {
    doctors: withSales.length,
    noSales: withoutSales.length,
    topAverage,
    thirtyCount: rows.reduce(
      (total, row) => total + (Number(row.np_30_count) || 0) + (Number(row.nc_30_count) || 0),
      0
    ),
    incomeTotal: rows.reduce((total, row) => total + (Number(row.income && row.income.total) || 0), 0),
  }
}

export function rankingRecords(rows, showIncome) {
  return rows.map(row => {
    const record = {
      Position: positionText(row),
      Doctor: row.doctor_name || '',
      Sales: hasSales(row) ? 'Sí' : 'No',
      'Avg NP+NC': plainNumber(row.avg_nc_np),
      'NP average': plainNumber(row.avg_np),
      'NP count': plainNumber(row.np_count),
      'NC average': plainNumber(row.avg_nc),
      'NC count': plainNumber(row.nc_count),
      '$30 NP': Number(row.np_30_count) || 0,
      '$30 NC': Number(row.nc_30_count) || 0,
    }
    if (showIncome) {
      record.Income = plainNumber(row.income && row.income.total)
      record.Visits = plainNumber(row.income && row.income.visits)
      record.Ticket = plainNumber(row.income && row.income.ticket)
    }
    return record
  })
}

export function noSalesMessage(count) {
  return count === 1
    ? '1 doctor inició sesión y no vendió en este rango'
    : `${count} doctores iniciaron sesión y no vendieron en este rango`
}

export function unwrapRanking(response) {
  const data = response && response.data
  if (!data || typeof data !== 'object' || !Array.isArray(data.ranking)) throw new Error(LOAD_ERROR)
  return data.ranking
}
